module.exports = __webpack_public_path__ + "img/Nedbank_Logo.2ee72ea7.svg";